/* eslint-disable no-unused-vars */
import { GetterTree, MutationTree, ActionTree } from "vuex";
import { UserApi } from "@/services/api/UserApi";

class State {
  isUserBusy: boolean;
  userItems: unknown [];
  userItem: unknown;
  userCurrent: unknown;
}

// Создаем объект
const userApi = new UserApi();

// Создаем геттеры
const getters = <GetterTree<State, any>>{

  isUserBusy(state): boolean {
    return state.isUserBusy;
  },

  getUserItems(state): unknown[] {
    return state.userItems;
  },

  getUserItem(state): unknown {
    return state.userItem;
  },

  getUserCurrent(state): unknown {
    return state.userCurrent;
  }
};

// Создаем мутации
const mutations = <MutationTree<State>>{

  setIsUserBusy(state, payload: boolean) {
    state.isUserBusy = payload
  },

  setUserItems(state, payload: unknown[]) {
    state.userItems = payload
  },

  setUserItem(state, payload: unknown) {
    state.userItem = payload
  },

  setUserCurrent(state, payload: unknown) {
    state.userCurrent = payload
  }
};

// Создаем действия
const actions = <ActionTree<State, any>>{

  // Текущий пользователь
  getUserCurrent({ commit }, data: any) {

    const user = localStorage.getItem('user');
    if (user) {
      commit('setUserCurrent', JSON.parse(user));
    }

    return null;
  },
  
  // Список элементов
  getUserItems({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsUserBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};
    const sort:any = data !== undefined && data.sort !== undefined ? data.sort : {};
    const pagination:any = data !== undefined && data.pagination !== undefined ? data.pagination : {};

    return new Promise((resolve, reject) => {

      // Получаем список элементов
      userApi.getUserItems(filter, sort, pagination)
        .then(
          (response) => {
            commit('setUserItems', response);
            commit('setIsUserBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsUserBusy', false);
            reject(error);
          }
        );
    });
  },

  // Получить элемент
  getUserItem({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsUserBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};

    return new Promise((resolve, reject) => {

      // Получаем элемент
      userApi.getUserItem(filter)
        .then(
          (response) => {
            commit('setUserItem', response);
            commit('setIsUserBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsUserBusy', false);
            reject(error);
          }
        );
    });
  },

  // Создать элемент
  createUserItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsUserBusy', true);

    return new Promise((resolve, reject) => {

      // Создаем элемент
      userApi.createUserItem(data)
        .then(
          (response) => {
            commit('setIsUserBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsUserBusy', false);
            reject(error);
          }
        );
    });
  },

  // Обновить элемент
  updateUserItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsUserBusy', true);

    return new Promise((resolve, reject) => {

      // Обновляем элемент
      userApi.updateUserItem(data)
        .then(
          (response) => {
            commit('setIsUserBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsUserBusy', false);
            reject(error);
          }
        );
    });
  },

  // Удалить элемент
  deleteUserItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsUserBusy', true);

    return new Promise((resolve, reject) => {

      // Удаляем элемент
      userApi.deleteUserItem(data)
        .then(
          (response) => {
            commit('setIsUserBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsUserBusy', false);
            reject(error);
          }
        );
    });
  }
};

// Создаем модуль
const UserModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default UserModule;